// extracted by mini-css-extract-plugin
module.exports = {"HomePage":"AwesomeHome_HomePage__2pYbH"};